<template>
  <div>
    <v-card>
      <v-card-text>

        <v-chip-group column>
          <v-chip small v-if="getProductListConfigs.kind.length!==0"><b class="mr-1">Kind:</b>{{getProductListConfigs.kind.join(', ')}}</v-chip>
          <v-chip small v-if="getProductListConfigs.tariff.length!==0"><b class="mr-1">Tariff:</b>{{getProductListConfigs.tariff.join(', ')}}</v-chip> 
          <v-chip small v-if="getProductListConfigs.status.length!==0"><b class="mr-1">Status:</b>{{getProductListConfigs.status.join(', ')}}</v-chip> 
          <v-chip small v-if="getProductListConfigs.statusReason.length!==0"><b class="mr-1">Status Reason:</b>{{getProductListConfigs.statusReason.join(', ')}}</v-chip>
          <v-chip small v-if="getProductListConfigs.upgradeStatus.length!==0"><b class="mr-1">Upgrade Status:</b>{{getProductListConfigs.upgradeStatus.join(', ')}}</v-chip> 
          <v-chip small v-if="getProductListConfigs.version.length!==0"><b class="mr-1">VoIP Version:</b>{{getProductListConfigs.version.join(', ')}}</v-chip>
          <v-chip small v-if="getProductListConfigs.supplier"><b class="mr-1">Supplier:</b>{{getProductListConfigs.supplier}}</v-chip> 
          <v-chip small v-if="getProductListConfigs.outOfContract"><b class="mr-1">Out of contract</b></v-chip> 
          <v-chip small v-if="getProductListConfigs.outOfPromo"><b class="mr-1">Out of promo period</b></v-chip> 
          <v-chip small v-if="voipMigrationFilter.selected"><b class="mr-1">VoIP migration:</b>{{voipMigrationFilter.data}}</v-chip> 
        </v-chip-group>

        <v-data-table multi-sort :loading="getProductListLoading" :headers="headers" :items="getProductList" class="body--text" :server-items-length="getProductListConfigs.paginationCount" :page.sync="getProductListConfigs.paginationPage" :options.sync="options" :footer-props="{itemsPerPageOptions: itemsPerPageOptions}">
          <template v-slot:item.id="{ item }">
            <a :href="`/products/${item.id}`" target="_blank">{{ item.id | textPlaceholder }}</a>
          </template>
          <template v-slot:item.account_id="{ item }">
            <a :class="item.account_id==='None' || !item.account_id ?'disable-pointer':''" :href="`/accounts/${item.account_id}`" target="_blank">{{ item.account_id==='None' || !item.account_id ? '-' : item.account_id | textPlaceholder }}</a>
          </template>
          <template v-slot:item.status="{ item }">{{ item.status | textPlaceholder }}</template>

          <template v-slot:item.status_reason="{ item }">
            {{ item.status_reason | textPlaceholder }}
          </template>

          <template v-slot:item.status_entry="{ item }">

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">{{ (item.status_entry)?item.status_entry:item.added | timeSince }}</div>
              </template>
              <span>{{(item.status_entry)?item.status_entry:item.added}}</span>
            </v-tooltip>      

          </template>
          <template v-slot:item.future_live_date="{ item }">

            <v-tooltip top v-if="item.future_live_date">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">{{ item.future_live_date | formatDate }}</div>
              </template>
              <span>In {{item.future_live_date | daysTill}}</span>
            </v-tooltip>

            <template v-else>-</template>

          </template>
          <template v-slot:item.product_kind="{ item }">{{ item.product_kind | kindMap | textPlaceholder }}</template>
          <template v-slot:item.live_date="{ item }">{{ item.live_date | formatDate | textPlaceholder }}</template>
          <template v-slot:item.contract_end_date="{ item }">{{ item.contract_end_date | formatDate | textPlaceholder }}</template>
          <template v-slot:item.ceased_date="{ item }">{{ item.ceased_date | formatDate | textPlaceholder }}</template>
          <template v-slot:item.action="{ item }"><LeadLink :leadid="item.id" /></template>
        </v-data-table>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import LeadLink from '@/components/Globals/LeadLink';
  import { mapGetters, mapActions } from "vuex";
  import moment from "moment";

  export default {

    components: {LeadLink},

    data() {
      return {
        options: {
          itemsPerPage: 50,
          sortBy: [],
          sortDesc: [],
        },
        itemsPerPageOptions: [5,10,15,25,50],
        headers: [
          { text: 'Product ID', align: 'start', sortable: false, value: 'id'},
          { text: 'Account ID', value: 'account_id', sortable: false, },
          { text: 'Status', value: 'status', sortable: false, },
          { text: 'Status Reason', value: 'status_reason', sortable: false },
          { text: 'Days in Status', value: 'status_entry', sortable: true, },
          { text: 'Future Live Date', value: 'future_live_date', sortable: true, },
          { text: 'Product Kind', value: 'product_kind', sortable: false, },
          { text: 'Live Date', value: 'live_date', sortable: true, },
          { text: 'Contract End Date', value: 'contract_end_date', sortable: true, },
          { text: 'Ceased date', value: 'ceased_date', sortable: true, },
          { text: '', value: 'action', sortable: false, },
        ],
      }
    },

    filters: {
      textPlaceholder(val) {
        if(val === null || val === "" || val === undefined) return "-";
        return val;
      },

      timeSince(val) {
        if(val === null || val === "" || val === undefined) return "-";
        const date = moment(new Date());
        const days = date.diff(moment(val), 'days');
        return `${days} day${days===1?'':'s'}`;
      },

      daysTill(val) {
        if(val === null || val === "" || val === undefined) return "-";
        const date = moment(new Date());
        const days = moment(val).diff(date, 'days');
        return `${days} day${days===1?'':'s'}`;
      },

      formatDate(val) {
        if(!val) return "-";
        const date = new Date(val);
        return moment(date).format('YYYY-MM-DD');
      },

      kindMap(val) {
        const kindMap = {
          "voip": "VoIP",
          "telco": "Telco",
          "web": "Web"
        }
        return kindMap[val.toLowerCase()];
      }
    },

    computed: {
      ...mapGetters("productList", ["getProductList", "getProductListLoading", "getProductListConfigs"]),
      voipMigrationFilter(){
        let options = ['hardware','audio','headset','nonGeo','ownPhoneSetup','crmConnect','ipex','phoneDelivery','callRecording','numberPort','international'];
        let selected = [];
        options.forEach(o => {
          if(this.getProductListConfigs[o]==='true'){
            selected.push(o);
          }
        });
        return {
          selected: selected.length>0,
          data: selected.join(', '),
        };
      },
    },

    methods: {
      ...mapActions("productList", ["fetchProductList", "updateProductListPagination"]),
    },

    watch: {
      immediate: true,
      options: {
        handler () {
          this.updateProductListPagination(this.options);
        },
        deep: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  .disable-pointer {
    pointer-events: none;
  }
</style>
